import { appGlobalErrorsHandler, appGlobalWarningsHandler } from '../errors/utils';
import { useNotifications } from '../store/notifications.store';

/**
 * Route Vue errors and warnings through our handlers.
 *
 * Call after Sentry's Vue integration has attached. Sentry wraps whatever `errorHandler` exists and
 * attaches the component's full props to the event; assigning ours afterwards replaces that wrapper,
 * so only prop keys are ever reported (EN-961).
 *
 * @param {import('vue').App} app
 */
export const installErrorHandlers = (app) => {
	app.config.errorHandler = appGlobalErrorsHandler(useNotifications);
	app.config.warnHandler = appGlobalWarningsHandler(useNotifications);
};
